/* eslint-disable */
/* eslint-enable */
/* eslint eqeqeq: 0, curly: 2 */

import {
  Typography,
  Banner,
  Button,
  Col,
  Form,
  Divider,
  Modal,
  Row,
  Tabs,
  TabPane,
  Toast,
  List,
  Avatar,
  Space,
  Tooltip,
  Popover,
  Tag,
  SideSheet,
  Switch as SemiSwitch,
  Radio as SemiRadio,
} from "@douyinfe/semi-ui";
import {
  ApiClient,
  getLeadStatusOpt,
  Lead,
  LeadAssignLog,
  LeadContactLog,
  LeadStarLog,
  displayLeadStatus,
  ReadOnlyLeadStatus,
  getSalesLeadStatusOpt,
  Loan,
  displayLoanStatus,
  LeadStatus,
  User,
  ApiResp,
  Page,
  ReadOnlyVisitLeadStatus,
  LoanContactLog,
} from "../../api/ApiClient";
import {
  IconHelpCircle,
  IconSave,
  IconUserCardPhone,
  IconRotate,
  IconChevronLeft,
  IconChevronRight,
  IconBell,
  IconLikeHeart,
  IconCopy,
  IconBookmark, IconModalStroked, IconUser,
  IconPlay, IconStar,
  IconFile, IconCalendar, IconEdit, IconList, IconAlertTriangle,
  IconRefresh,
} from "@douyinfe/semi-icons";
import React, { useEffect, useState, useRef } from "react";
import AudioPlayerModal from "../../comp/AudioPlayerModal";
import "./leadDetail.css";
import { CrudOption } from "../../comp/crud";
import DictCheckboxGroup from "../../comp/DictCheckboxGroup";
import {
  avatarName,
  formatDateTime,
  displayStar,
  StarList,
  formatRelativeTime,
} from "../../utils";
import { FormApi } from "@douyinfe/semi-ui/lib/es/form";
import pubsub from "pubsub-js";
import IndexMortgageLoan from "../mortgageLoan/indexMortgageLoan";

export interface LeadDetailNewProps {
  viewMode?: boolean;
  visitMode?: boolean;
  findLeadMode?: boolean;
  leadId?: number;
  leadIds?: number[];
  queryParams?: any;
  onOk?: () => void;
  onCancel?: () => void;
  onSentToPool?: () => void;
  newWindow?: boolean;
  leadFrom?: string;
}

const Title = Typography.Title;
const apiClient = ApiClient.getDefault();
const {
  TextArea,
  Section,
  Input,
  DatePicker,
  TimePicker,
  Select,
  Switch,
  InputNumber,
  Checkbox,
  CheckboxGroup,
  RadioGroup,
  Radio,
} = Form;
const starHelp = (
  <p style={{ lineHeight: "2em" }}>
    1星：客户是没有可贷点；人在外地（本人不在本地工作者）
    <br />
    2星：有按揭车、全款车、商业保单、企业或则个体户有纳税
    <br />
    3星：外地按揭房、外地全款房、外地公积金
    <br />
    4星：本地有缴纳公积金
    <br />
    5星：本地按揭房、本地全款房、本地回迁房有证
    <br />
    （客户如果是多个条件，则选择最高星级）
  </p>
);
const callPhoneHelp = (
  <p style={{ lineHeight: "2em" }}>
    1：要使用拨号功能 ，请下载APP，使用自己的账号和密码登录
    <br />
    2：若提示手机端不在线，请先登录手机端，若APP连接服务器失败，请点击手动连接按钮
  </p>
);
const contactLogTemplate = [
  "无需贷款",
  "未接电话",
  "客户挂机",
  "客户关机",
  "空号",
  "拨打的用户正忙  请稍后再拨",
  "停机",
  "提贷挂",
  "通话中",
  "转语音留言",
  "现在忙，稍后联系",
];

/** 旧字典值 → V2 推荐值映射提示（一对多用 / 分隔） */
const OLD_TO_V2_HINT: Record<string, Record<string, string>> = {
  houseV2: {
    "有房按揭中": "按揭住宅 / 按揭公寓",
    "有房无按揭": "全款住宅 / 全款公寓",
    "小产权": "小产权/安置房",
  },
  vehicleV2: {
    "有车按揭中": "按揭燃油车 / 按揭新能源车",
    "有车无按揭": "全款燃油车 / 全款新能源车",
  },
  socialSecurityV2: {
    "有社保": "单位缴纳 / 个人缴纳 / 灵活就业",
  },
  companyV2: {
    "有公司": "个体经营 / 中小微企业",
    "无公司": "无固定单位",
  },
  providentFundV2: {
    "有公积金": "月缴<500 / 月缴500~1500 / 月缴1500以上",
  },
  incomeV2: {
    "2万以上": "2~5万 / 5万以上",
  },
  creditV2: {
    "良好": "正常(无逾期)",
    "不良": "轻微逾期(已结清) / 严重逾期(已结清) / 当前逾期",
  },
  loanTypeV2: {
    "信用": "信用贷",
    "抵押": "房产抵押贷 / 车辆抵押贷",
  },
};

/** 字段名 → 中文标签（用于旧值检测提示） */
const FIELD_LABEL_MAP: Record<string, string> = {
  marriage: '婚姻',
  loanType: '贷款类型',
  house: '房产',
  vehicle: '车产',
  company: '公司',
  providentFund: '公积金',
  socialSecurity: '社保',
  income: '收入',
  workYears: '工作年限',
  credit: '征信',
};

/** 字典选项缓存 */
interface DictCache {
  [code: string]: CrudOption[];
}

/** 意向等级 → 徽章配色 */
const getIntentionColor = (lvl?: string) =>
  lvl === "A" ? "#22c55e" : lvl === "B" ? "#facc15" :
  lvl === "C" ? "#f97316" : lvl === "D" ? "#ef4444" : "#9ca3af";
const getIntentionText = (lvl?: string) =>
  lvl === "A" ? "意向高" : lvl === "B" ? "意向中" :
  lvl === "C" ? "意向低" : lvl === "D" ? "无意向" : "待定";

export function LeadDetailNew(props: LeadDetailNewProps) {
  const [leadContactLogs, setLeadContactLogs] = useState(
    [] as LeadContactLog[]
  );
  const [leadAssignLogs, setLeadAssignLogs] = useState([] as LeadAssignLog[]);
  const [leadStarLogs, setLeadStarLogs] = useState([] as LeadStarLog[]);
  const [contactLogSaving, setContactLogSaving] = useState(false);
  const [helpVisible, setHelpVisible] = useState(false);
  const [activeHelpCategory, setActiveHelpCategory] = useState('');
  
  const [leadSaving, setLeadSaving] = useState(false);

  const [showMobile, setShowMobile] = useState(true);

  const [loans, setLoans] = useState([] as Loan[]);
  const [lead, setLead] = useState(undefined as undefined | Lead);
  const [leadId, setLeadId] = useState<number>();
  const [leadIds, setLeadIds] = useState<number[]>();
  const [userInfoForm, setUserInfoForm] = useState<any>();
  const [statusForm, setStatusForm] = useState<any>();
  const [visitForm, setVisitForm] = useState<any>();
  const [logForm, setLogForm] = useState<any>();
  const [loadingAll, setLoadingAll] = useState(false);
  const [showInfo, setShowInfo] = useState(
    apiClient.getPref<boolean>("userInfo")
  );
  const [showTodo, setShowTodo] = useState(false);
  const [todoFormApi, setTodoFormApi] = useState<any>();
  const [savingTodo, setSavingTodo] = useState(false);
  const [poolSaving, setPoolSaving] = useState(false);
  const [starInfoAll, setStarInfoAll] = useState<CrudOption[]>([]);
  const [starInfo, setStarInfo] = useState<CrudOption[]>([]);
  const formRef = useRef(null);
  const [statusInfoAll, setStatusInfoAll] = useState<CrudOption[]>([]);
  const [statusInfo, setStatusInfo] = useState<CrudOption[]>([]);
  let [admin, setAdmin] = useState<User>();
  const [readOnlyLeadStatus, setReadOnlyLeadStatus] = useState([] as any);
  const [viewMode, setViewMode] = useState(false);
  const [savingFav, setSavingFav] = useState(false);
  const [leadFav, setLeadFav] = useState(false);
  const [leadMy, setLeadMy] = useState(false);
  const [visitSignLogText, setVisitSignLogText] = useState("");
  const [actVisitTimeDisabled, setActVisitTimeDisabled] = useState(true);
  const role = localStorage.getItem("role");
  const username = localStorage.getItem("username");
  const city = localStorage.getItem("city");

  const [selectedLeads, setSelectedLeads] = useState([] as any[]);
  const [assignSaving, setAssignSaving] = useState(false);
  const [selectedMembers, setSelectedMembers] = useState([] as any[]);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [assignFormApi, setAssignFormApi] = useState<any>(undefined);
  const [teamMembersTree, setTeamMembersTree] = useState([] as any[]);
  const [loanContactLogs, setLoanContactLogs] = useState(
    [] as LoanContactLog[]
  );

  // 通话记录相关
  interface CallLogItem {
    id: number;
    leadName: string;
    leadMobile: string;
    saleName: string;
    status: string;
    callAt: string;
    startAt: string;
    endAt: string;
    callTimeLong: number;
    recordFile: string;
    recordName: string;
    recordUploaded: boolean;
  }
  const [callLogs, setCallLogs] = useState([] as CallLogItem[]);
  const [callAudioVisible, setCallAudioVisible] = useState(false);
  const [callAudioUrl, setCallAudioUrl] = useState("");
  const [callAudioTitle, setCallAudioTitle] = useState("");

  const [showMortgageLoan, setShowMortgageLoan] = useState(false);
  const [hasAssignPriv, setHasAssignPriv] = useState(false);

  // V2 字典缓存
  const [dicts, setDicts] = useState<DictCache>({});
  /** 精简模式：只显示选中的字典值 */
  const [compactMode, setCompactMode] = useState(false);
  const [llmScoring, setLlmScoring] = useState(false);

  const loadDicts = async () => {
    const codes = [
      "genderV2", "marriageV2", "city", "incomeV2", "workYearsV2",
      "socialSecurityV2", "providentFundV2", "creditV2", "loanTypeV2",
      "jobV2", "houseV2", "vehicleV2", "companyV2",
    ];
    const v2Codes = new Set(codes.filter(c => c.endsWith("V2")));

    // 一次性批量获取所有字典
    const batchData = await apiClient.getDictBatch(codes);

    // 角色判断（与 getDictAsOpts 保持一致）
    const role = localStorage.getItem("role");
    const city = localStorage.getItem("city");
    const isRestrictedRole = (role !== "root" && role !== "op_manager" && role !== "source" && role !== "monitor") && city;

    // 处理每个字典，V2 字典需要解析嵌套格式
    const cache: DictCache = {};
    for (const code of codes) {
      const rawItems = batchData[code] || [];

      // "city" 字典：受限制角色只显示用户所在城市
      if (code === "city" && isRestrictedRole) {
        cache[code] = [{ label: city!, value: city!, key: city! }];
        continue;
      }

      if (v2Codes.has(code)) {
        // V2 字典：解析嵌套 JSON 格式
        cache[code] = rawItems.map((v: string) => {
          try {
            const parsed = JSON.parse(v);
            return {
              label: parsed.label,
              value: parsed.label,
              key: parsed.label,
              children: parsed.children ? parsed.children.map((c: string) => ({
                label: c,
                value: parsed.label + "-" + c,
                key: parsed.label + "-" + c,
              })) : undefined,
            };
          } catch {
            return { label: v, value: v, key: v };
          }
        });
      } else {
        // 普通字典：直接映射
        cache[code] = rawItems.map((v: string) => ({
          label: v,
          value: v,
          key: v,
        }));
      }
    }
    setDicts(cache);
  };

  /** 渲染扁平 RadioGroup 字典选择器（兼容旧字典值，支持精简模式） */
  const renderDictRadio = (dictCode: string, field: string, label: string, formApi?: any) => {
    const opts = dicts[dictCode];
    if (!opts || opts.length === 0) return null;
    // 兼容旧字典值：当前值不在V2选项中时，注入旧值以便展示
    const currentVal = formApi?.getValue(field);
    const compatOpts = [...opts];
    if (currentVal != null && currentVal !== '' && !opts.some(o => String(o.value) === String(currentVal))) {
      compatOpts.unshift({
        key: `__legacy_${currentVal}`,
        value: currentVal,
        label: `${currentVal}(旧)`,
      });
    }

    // 精简模式：隐藏表单控件 + 显示选中值 Tag
    if (compactMode) {
      const selectedOpt = currentVal ? compatOpts.find(o => String(o.value) === String(currentVal)) : null;
      const isLegacy = selectedOpt ? String(selectedOpt.key).startsWith('__legacy_') : false;
      const hint = isLegacy ? (OLD_TO_V2_HINT[dictCode]?.[String(currentVal)] || null) : null;
      const tagEl = currentVal ? (
        <Tag
          color={isLegacy ? 'orange' : 'blue'}
          style={{ cursor: 'pointer', fontSize: 13, margin: 0 }}
          onClick={() => setCompactMode(false)}
        >
          {selectedOpt?.label || String(currentVal)}
        </Tag>
      ) : (
        <Tag color="grey" style={{ fontSize: 13, margin: 0 }}>未填</Tag>
      );
      return (
        <>
          <Form.RadioGroup field={field} style={{ display: 'none', gap: 10}} noLabel>
            {compatOpts.map((o) => (
              <Form.Radio key={o.key} value={o.value}>{o.label}</Form.Radio>
            ))}
          </Form.RadioGroup>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '4px 10px' }}>
            <span style={{ color: 'var(--semi-color-text-2)', fontSize: 13, minWidth: 56 }}>{label}</span>
            {currentVal && isLegacy && hint ? (
              <Tooltip content={`建议更新为：${hint}`}>{tagEl}</Tooltip>
            ) : currentVal ? (
              <Tooltip content="点击展开选项">{tagEl}</Tooltip>
            ) : tagEl}
          </div>
        </>
      );
    }

    return (
      <Form.RadioGroup key={dictCode} field={field} label={{
                              text: label,
                              
                            }} 
        style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
        {compatOpts.map((o) => {
          const isLegacy = String(o.key).startsWith('__legacy_');
          const hint = isLegacy ? (OLD_TO_V2_HINT[dictCode]?.[String(currentVal)] || null) : null;
          const radio = (
            <Form.Radio key={o.key} value={o.value}>
              <span style={isLegacy ? { color: 'var(--semi-color-warning)' } : undefined}>
                {o.label}
              </span>
            </Form.Radio>
          );
          return isLegacy ? (
            <Tooltip key={o.key} content={hint ? `建议更新为：${hint}` : '请选择新选项'}>
              {radio}
            </Tooltip>
          ) : radio;
        })}
      </Form.RadioGroup>
    );
  };


  /** 渲染扁平多选 CheckboxGroup 字典选择器（兼容旧字典值，带迁移提示，支持精简模式） */
  const renderDictMultiSelect = (dictCode: string, field: string, label: string, formApi: any) => {
    const opts = dicts[dictCode];
    if (!opts || opts.length === 0) return null;
    // 兼容旧字典值：当前值中有不在V2选项中的旧值时，注入它们
    const currentVal = formApi?.getValue(field);
    const compatOpts = [...opts];
    if (currentVal && typeof currentVal === 'string') {
      const valArr = currentVal.split(',').filter((v: string) => v.trim());
      const optValues = new Set(opts.map(o => String(o.value)));
      valArr.forEach((v: string) => {
        const trimmed = v.trim();
        if (trimmed && !optValues.has(trimmed)) {
          compatOpts.unshift({
            key: `__legacy_${trimmed}`,
            value: trimmed,
            label: `${trimmed}(旧)`,
          });
        }
      });
    }

    // 精简模式：隐藏表单控件 + 显示选中值 Tags
    if (compactMode) {
      const valArr = currentVal ? String(currentVal).split(',').filter((v: string) => v.trim()) : [];
      const legacyHints: Record<string, string> = OLD_TO_V2_HINT[dictCode] || {};
      return (
        <>
          <div style={{ position: 'absolute', width: 0, height: 0, overflow: 'hidden', pointerEvents: 'none' }}>
            <DictCheckboxGroup
              field={field}
              label=""
              options={compatOpts}
              value={formApi.getValue(field)}
              onChange={(val: string) => formApi.setValue(field, val)}
            />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '4px 10px', flexWrap: 'wrap' }}>
            <span style={{ color: 'var(--semi-color-text-2)', fontSize: 13, minWidth: 56 }}>{label}</span>
            {valArr.length > 0 ? valArr.map((v: string) => {
              const trimmed = v.trim();
              const opt = compatOpts.find(o => String(o.value) === trimmed);
              const isLegacy = opt ? String(opt.key).startsWith('__legacy_') : false;
              const hint = isLegacy ? legacyHints[trimmed] : null;
              const tagEl = (
                <Tag
                  key={trimmed}
                  color={isLegacy ? 'orange' : 'blue'}
                  style={{ cursor: 'pointer', fontSize: 13, margin: 0 }}
                  onClick={() => setCompactMode(false)}
                >
                  {opt?.label || trimmed}
                </Tag>
              );
              return isLegacy && hint ? (
                <Tooltip key={trimmed} content={`建议更新为：${hint}`}>{tagEl}</Tooltip>
              ) : (
                <Tooltip key={trimmed} content="点击展开选项">{tagEl}</Tooltip>
              );
            }) : (
              <Tag color="grey" style={{ fontSize: 13, margin: 0 }}>未填</Tag>
            )}
          </div>
        </>
      );
    }

    // 构建旧值→推荐提示映射
    const legacyHints: Record<string, string> = OLD_TO_V2_HINT[dictCode] || {};
    return (
      <DictCheckboxGroup
        field={field}
        label={label}
        options={compatOpts}
        value={formApi.getValue(field)}
        onChange={(val: string) => formApi.setValue(field, val)}
        legacyHints={legacyHints}
      />
    );
  };

  /** 检测当前客户有哪些字段使用了旧字典值 */
  const detectLegacyFields = (): string[] => {
    if (!lead) return [];
    const dictFieldMap: Record<string, string> = {
      marriage: 'marriageV2',
      loanType: 'loanTypeV2',
      house: 'houseV2',
      vehicle: 'vehicleV2',
      company: 'companyV2',
      providentFund: 'providentFundV2',
      socialSecurity: 'socialSecurityV2',
      income: 'incomeV2',
      workYears: 'workYearsV2',
      credit: 'creditV2',
    };
    const multiSelectFields = new Set(['loanType', 'house', 'vehicle']);
    const legacyFields: string[] = [];
    for (const [field, dictCode] of Object.entries(dictFieldMap)) {
      const val = (lead as any)?.[field];
      if (!val) continue;
      const opts = dicts[dictCode];
      if (!opts || opts.length === 0) continue;
      const optValues = new Set(opts.map(o => String(o.value)));
      if (multiSelectFields.has(field)) {
        const valArr = String(val).split(',').filter((v: string) => v.trim());
        for (const v of valArr) {
          if (v.trim() && !optValues.has(v.trim())) {
            legacyFields.push(FIELD_LABEL_MAP[field] || field);
            break;
          }
        }
      } else {
        if (!optValues.has(String(val))) {
          legacyFields.push(FIELD_LABEL_MAP[field] || field);
        }
      }
    }
    return legacyFields;
  };

  let getAdmin = async () => {
    try {
      await apiClient.initToken();
      let admin = (await apiClient.getCurrentAdmin()).data;
      setAdmin(admin);
    } catch (e) { }
  };

  const loadLead = async () => {
    if (leadId == undefined) {
      return Promise.resolve(undefined);
    }
    let l = await apiClient.getLead(leadId);
    console.log("leadStatus: " + l.status);
    if (props.visitMode || String(l.status) == "VISITED") {
      console.log("visitMode");
      setReadOnlyLeadStatus(ReadOnlyVisitLeadStatus);
    } else {
      setReadOnlyLeadStatus(ReadOnlyLeadStatus);
    }
    userInfoForm?.setValues(l);
    statusForm?.setValues(l);
    visitForm?.setValues(l);
    logForm?.setValues(l);

    if (props.newWindow) {
      window.document.title = "客户:" + l?.name;
    }
    //加载星级和状态
    let statusOpt = getSalesLeadStatusOpt();
    setStatusInfoAll(statusOpt);

    if (l?.star == 0) {
      setStatusInfo(
        statusOpt.filter((item) => {
          return item.value == "PENDING_CONTACT" || item.value == "UNREACHABLE";
        })
      );

      if (
        String(l.status) != "PENDING_CONTACT" &&
        String(l.status) != "UNREACHABLE"
      ) {
        let newLeadStatus: LeadStatus = "PENDING_CONTACT" as LeadStatus;
        l.status = newLeadStatus;
      }
    } else if (l?.star == 1) {
      setStatusInfo(
        statusOpt.filter((item) => {
          return item.value != "PENDING_CONTACT" && item.value != "UNREACHABLE";
        })
      );

      if (
        String(l.status) == "PENDING_CONTACT" ||
        String(l.status) == "UNREACHABLE"
      ) {
        let newLeadStatus: LeadStatus = "OUT_LEAD" as LeadStatus;
        l.status = newLeadStatus;
      }
    } else {
      setStatusInfo(
        statusOpt.filter((item) => {
          return (
            item.value != "PENDING_CONTACT" &&
            item.value != "UNREACHABLE" &&
            item.value != "OUT_LEAD" &&
            item.value != "NON_COMPLIANCE"
          );
        })
      );
      if (
        String(l.status) == "PENDING_CONTACT" ||
        String(l.status) == "UNREACHABLE" ||
        String(l.status) == "OUT_LEAD"
      ) {
        let newLeadStatus: LeadStatus = "PENDING_VISIT" as LeadStatus;
        l.status = newLeadStatus;
      }
    }

    setLead(l);
    setLeadFav(l.fav);
    setLeadMy(String(l.leadType) == "MY");

    // AI 评分徽章刷新

    let starArr = StarList.map((s) => {
      return {
        label: displayStar(s),
        value: s,
        key: s + "",
      };
    });
    setStarInfoAll(starArr);
    setStarInfo(starArr);
  };

  const loadLeadIds = async () => {
    if (!props.queryParams) {
      return;
    }

    if (props.leadFrom == "visitSignLog") {
      let apiResp: ApiResp<Page<any>> = await apiClient.request(
        "/leadVisitSignLog",
        "GET",
        props.queryParams
      );
      let leadIdsLocal = apiResp.data.records.map((v) => v.leadId);
      return leadIdsLocal;
    } else {
      let apiResp: ApiResp<Page<any>> = await apiClient.request(
        "/leads",
        "GET",
        props.queryParams
      );
      let leadIdsLocal = apiResp.data.records.map((v) => v.id);
      return leadIdsLocal;
    }
  };

  const loadLeadContactLogs = () => {
    return apiClient
      .getAllLeadContactLogs(leadId!)
      .then((logs) => setLeadContactLogs(logs));
  };

  const loadLoanContactLogs = () => {
    return apiClient
      .getAllLoanContactLogs(leadId!)
      .then((logs) => setLoanContactLogs(logs));
  };

  const callStatusLabels: Record<string, string> = {
    ENABLED: "启用", DISABLED: "停用", CALLING: "拨号中",
    CONNECTED: "已接通", ENDED: "已接通", MISSED: "未接通",
  };
  const callStatusColors: Record<string, any> = {
    ENABLED: "green", DISABLED: "grey", CALLING: "blue",
    CONNECTED: "green", ENDED: "green", MISSED: "red",
  };
  const formatCallSeconds = (s: number | null | undefined): string => {
    if (s === null || s === undefined || s < 0) return "-";
    return `${Math.floor(s / 60)}:${(s % 60).toString().padStart(2, "0")}`;
  };

  const loadCallLogs = () => {
    return apiClient
      .request<Page<CallLogItem>>("/leadCallLog", "GET", {
        leadId: leadId,
        page: 1,
        size: 9999,
      })
      .then((resp) => setCallLogs(resp.data.records));
  };

  const playCallAudio = (url: string, title: string) => {
    setCallAudioUrl(url);
    setCallAudioTitle(title);
    setCallAudioVisible(true);
  };
  const closeCallAudio = () => {
    setCallAudioVisible(false);
    setCallAudioUrl("");
  };

  const loadLeadAssignLogs = () => {
    apiClient
      .getAllLeadAssignLogs(leadId!)
      .then((logs) => setLeadAssignLogs(logs));
  };

  const loadLeadStarLogs = () => {
    apiClient.getAllLeadStarLogs(leadId!).then((logs) => setLeadStarLogs(logs));
  };

  const loadLeadVisitAssignLogs = () => {
    apiClient.getAllLeadVisitAssignLogs(leadId!).then((logs) => {
      let logText = "";
      logs.forEach((log) => {
        if (log.confirmAt) {
          logText = logText + log.saleName + "  " + log.createdAt + "\r\n";
        } else {
          logText = logText + log.saleName + "  " + log.createdAt + "(未确认)\r\n";
        }

      });
      setVisitSignLogText(logText);
    });
  };

  const loanLeadLoans = () => {
    apiClient.getAllLeadLoans(leadId!).then((l) => setLoans(l));
  };

  const refreshParentLead = () => {
    localStorage.setItem("new-refresh", "true");
    localStorage.setItem("my-refresh", "true");
    localStorage.setItem("fav-refresh", "true");
    localStorage.setItem("team-refresh", "true");
    localStorage.setItem("pool-refresh", "true");
    pubsub.publish("refreshMenuCount", "");
  };

  const handleSendToPool = async () => {
    Modal.confirm({
      title: "是否确认要送回公共池?",
      content: "",
      onOk: async () => {
        setPoolSaving(true);
        try {
          await apiClient.request("/leads/pool", "POST", undefined, {
            leadIds: [leadId!],
          });
          Toast.info("已送回公共池");
          props.onSentToPool && props.onSentToPool();
          refreshParentLead();
          setPoolSaving(false);
        } catch (e) {
          setPoolSaving(false);
        }
      },
    });
  };

  const handleSendToReassignPool = async () => {
    if (!lead?.saleId) {
      Toast.warning("当前客户未分配销售，无法退回到再分配池");
      return;
    }
    Modal.confirm({
      title: "是否确认退回到再分配池?",
      content: "确认后客户将分配给当前销售进入再分配池",
      onOk: async () => {
        setPoolSaving(true);
        try {
          await apiClient.request("/leads/assign", "POST", undefined, {
            leadIds: [leadId!],
            assignToIds: [lead.saleId],
          });
          Toast.info("已退回到再分配池");
          refreshParentLead();
          setPoolSaving(false);
        } catch (e) {
          setPoolSaving(false);
        }
      },
    });
  };

  const nextLeadId = () => {
    if (!leadIds) {
      return undefined;
    }
    const i = leadIds.indexOf(leadId!);
    return leadIds[i + 1];
  };

  const preLeadId = () => {
    if (!leadIds) {
      return undefined;
    }
    const i = leadIds.indexOf(leadId!);
    return leadIds[i - 1];
  };

  const handleNextClick = async () => {
    if (!props.queryParams) {
      return;
    }
    let nextId = nextLeadId();
    if (!nextId) {
      if (props.leadFrom == 'report') {
        Toast.warning("该页已经没有下一条数据了，请切换到下一页后再打开客户详情");
        return;
      } else {
        props.queryParams.page = parseInt(props.queryParams.page) + 1;
        let leadIdsLocal = await loadLeadIds();
        setLeadIds(leadIdsLocal);
        if (leadIdsLocal && leadIdsLocal.length > 0) {
          nextId = leadIdsLocal[0];
        } else {
          Toast.warning("没有下一条");
          return;
        }
      }
    }
    setLeadId(nextId);
  };

  const handlePrevClick = async () => {
    if (!props.queryParams) {
      return;
    }
    let preId = preLeadId();
    if (!preId) {
      if (props.leadFrom == 'report') {
        Toast.warning("该页已经没有上一条数据了，请切换到上一页后再打开客户详情");
        return;
      } else {
        if (props.queryParams.page == 1) {
          Toast.warning("没有上一条");
          return;
        }
        props.queryParams.page = parseInt(props.queryParams.page) - 1;
        let leadIdsLocal = await loadLeadIds();
        setLeadIds(leadIdsLocal);
        if (leadIdsLocal && leadIdsLocal.length > 0) {
          preId = leadIdsLocal[leadIdsLocal.length - 1];
        } else {
          Toast.warning("没有上一条");
          return;
        }
      }

    }
    setLeadId(preId);
  };

  const loadAll = async () => {
    if (!leadId) {
      console.log("没有leadId");
      return;
    }
    setLoadingAll(true);
    try {
      await loadLead();
      loadLeadContactLogs();
      loadLoanContactLogs();
      loadCallLogs();
      loadLeadAssignLogs();
      loadLeadStarLogs();
      loadLeadVisitAssignLogs();
      loanLeadLoans();
      setLoadingAll(false);
    } catch (e) {
      setLoadingAll(false);
    }
  };

  useEffect(() => {
    const body = document.body;
    let themeMode = localStorage.getItem("theme-mode");
    if (themeMode == "light") {
      body.removeAttribute("theme-mode");
    } else if (themeMode == "dark") {
      body.setAttribute("theme-mode", "dark");
    } else {
      body.removeAttribute("theme-mode");
    }

    setLeadId(props.leadId);

    if (role == "source") {
      setShowMobile(false);
    }
    if (props.leadFrom == 'report' && props.leadIds && props.leadIds.length >= 0) {
      setLeadIds(props.leadIds);
    } else {
      loadLeadIds().then((data) => setLeadIds(data));
    }

    if (role == "root" || role == "monitor") {
      setActVisitTimeDisabled(false);
    }

    let isManager = role == "quzhang" || role == "sale_manager" || role == "op_manager" || role == "monitor" || role == "root";
    setHasAssignPriv(isManager);

    let currUsername;
    if (role == "op_manager" || role == "monitor") {
      currUsername = "root";
    } else {
      currUsername = username;
    }
    apiClient
      .getTeamMemberTreeAsOptsOfAny(currUsername)
      .then((opts) => setTeamMembersTree(opts));

    // 加载 V2 字典
    loadDicts();
  }, [props.leadId]);

  useEffect(() => {
    if (leadId) {
      loadAll();
    } else {
      setLead(undefined);
    }
  }, [leadId]);

  const handleToggleUserInfo = () => {
    const result = !showInfo;
    setShowInfo(result);
    apiClient.putPref("userInfo", result);
  };
  const handleTodoSubmit = async () => {
    await todoFormApi!.validate();
    const values = todoFormApi!.getValues();
    const content = values["content"];
    const dueDate = formatDateTime(values["dueDate"]);
    setSavingTodo(true);
    try {
      await apiClient.request("/todos", "POST", undefined, {
        leadId: leadId,
        content: content,
        dueDate: dueDate,
      });
      setSavingTodo(false);
      todoFormApi?.reset();
      setShowTodo(false);
      Toast.info("提醒信息已保存");
    } catch (e) {
      setSavingTodo(false);
    }
  };

  const handleAssignButtonClick = () => {
    setSelectedLeads([lead]);
    setShowAssignModal(true);
    let strIds = localStorage.getItem("assignToIds");
    if (strIds) {
      apiClient
        .request("/users/removeLeaveUserId", "GET", {
          ids: JSON.parse(strIds),
        })
        .then((resp: ApiResp<any>) => {
          setSelectedMembers(resp.data);
        });
    }
  };

  const handleAssignClick = async () => {
    setAssignSaving(true);
    try {
      await assignFormApi!.validate();
      await apiClient.request(
        "/leads/assign",
        "POST",
        undefined,
        assignFormApi!.getValues()
      );
      let assignToIds = assignFormApi!.getValue("assignToIds");
      localStorage.setItem("assignToIds", JSON.stringify(assignToIds));

      setSelectedLeads([]);
      localStorage.setItem("my-refresh", "true");
      localStorage.setItem("new-refresh", "true");
      localStorage.setItem("all-refresh", "true");
      setAssignSaving(false);
      setShowAssignModal(false);

      pubsub.publish("refreshMenuCount", "");
    } catch (e) {
      setAssignSaving(false);
    }
  };

  const renderLabel = (label: any, item: any) => (
    <div style={{
      padding: '6px 8px',
      lineHeight: 1.0
    }}>
      <div style={{
        fontWeight: 500,
        color: 'var(--semi-color-text-0)',
        fontSize: 14
      }}>
        {label}
        <span style={{
          fontSize: 12,
          color: 'var(--semi-color-text-2)',
          marginLeft: 10
        }}>
          {item.labelSubText}
        </span>
      </div>
    </div>
  );

  const openMortgageLoanModal = async (leadId: number, leadName: string) => {
    const w = window.open("about:blank");
    if (w != null) {
      const data = {
        id: leadId,
        name: leadName,
      };
      w.location.href =
        "/#/newleadLoan?data=" + encodeURIComponent(JSON.stringify(data));
    }
  };

  const openHelpPage =  () => {
    
    console.log("============"+helpVisible);
    setHelpVisible(true);
    
  };

  const rules = [{ required: true, message: "请填写" }];
  return !lead ? null : (
    <div>
      <Modal icon={<IconModalStroked size={"extra-large"} style={{ color: 'blue' }} />} title={"贷款信息：" + leadId}
        style={{ width: '1500px', height: '750px' }}
        headerStyle={{
          flexShrink: 0,
          borderBottom: '1px solid var(--semi-color-border)'
        }}
        bodyStyle={{
          overflow: 'auto',
          padding: '5px 5px',
          flex: 1
        }}
        footer={null}
        hasCancel={false} onCancel={() => setShowMortgageLoan(false)} onOk={() => setShowMortgageLoan(false)}
        visible={showMortgageLoan}>
        <div><IndexMortgageLoan leadId={leadId} /></div>
      </Modal>
      <Modal
        icon={<IconModalStroked size={"extra-large"} style={{ color: 'blue' }} />}
        title="新建提醒"
        visible={showTodo}
        onCancel={() => setShowTodo(false)}
        onOk={handleTodoSubmit}
        confirmLoading={savingTodo}
      >
        <Form getFormApi={(api) => setTodoFormApi(api)}>
          <Form.TextArea
            rules={rules}
            placeholder="提醒内容"
            rows={2}
            noLabel
            field="content"
          />
        </Form>
      </Modal>
      <Modal
        icon={<IconModalStroked size={"extra-large"} style={{ color: 'blue' }} />}
        style={{ width: 600, height: 600 }}
        title="分配客户"
        visible={showAssignModal}
        okText="分配"
        confirmLoading={assignSaving}
        onOk={handleAssignClick}
        onCancel={() => setShowAssignModal(false)}
      >
        <Form getFormApi={(formApi) => setAssignFormApi(formApi)}>
          <Form.TreeSelect
            placeholder="请选择分配给谁"
            rules={[{ required: true, message: "请填写" }]}
            style={{ width: "100%" }}
            field="assignToIds"
            label="销售"
            checkRelation="unRelated"
            leafOnly
            multiple
            treeData={teamMembersTree}
            initValue={selectedMembers}
            filterTreeNode
            showFilteredOnly={true}
            searchPlaceholder="请输入关键字开始搜索"
            renderLabel={renderLabel}
            autoAdjustOverflow={false}
            virtualize={{
              itemSize: 28,
              height: 400
            }}
          ></Form.TreeSelect>
          <Form.Select
            rules={[{ required: true, message: "请填写" }]}
            disabled
            initValue={selectedLeads.map((l) => l.id)}
            style={{ width: "100%" }}
            multiple
            field="leadIds"
            label="客户"
          >
            {selectedLeads.map((l) => (
              <Form.Select.Option key={l.id + ""} value={l.id}>
                {l.name}
              </Form.Select.Option>
            ))}
          </Form.Select>
        </Form>
      </Modal>
      <Modal
              className="lead-detail"
              footer={<div></div>}
              fullScreen
              visible={props.leadId != undefined}
              onOk={props.onOk}
              onCancel={props.onCancel}
              closeOnEsc={true}
            >
        <Form<Lead>
          style={{margin:"5px"}}
          getFormApi={(api) => setUserInfoForm(api)}
          labelAlign="right"
          labelWidth={100}
          labelPosition="left"
          initValues={lead}
          render={(form) => {
            const handleSubmit = async () => {
              setLeadSaving(true);

              const actVisitTimeNew:any = form.formApi.getValue("actVisitTimeNew");
              const estVisitTime:any = form.formApi.getValue("estVisitTime");
              const signedContractAt:any =
                form.formApi.getValue("signedContractAt");
              const paidReturnAt:any =
                form.formApi.getValue("paidReturnAt");
              try {
                form.formApi.validate();
                await apiClient.request("/leads", "PUT", undefined, {
                  ...form.formApi.getValues(),
                  actVisitTimeNew:
                    typeof actVisitTimeNew == "string"
                      ? actVisitTimeNew
                      : formatDateTime(actVisitTimeNew),
                  estVisitTime:
                    typeof estVisitTime == "string"
                      ? estVisitTime
                      : formatDateTime(estVisitTime),
                  signedContractAt:
                    typeof signedContractAt == "string"
                      ? signedContractAt
                      : formatDateTime(signedContractAt),
                  paidReturnAt:
                    typeof paidReturnAt == "string"
                      ? paidReturnAt
                      : formatDateTime(paidReturnAt),
                });
                setLeadSaving(false);
                Toast.info("客户信息已保存");
                form.formApi.setValue("content", "");
                refreshParentLead();
                loadLeadContactLogs();
                loadLeadStarLogs();
              } catch (e) {
                setLeadSaving(false);
              }
            };

            const starChangeEvent = (value: any) => {
              if (value == 0) {
                setStatusInfo(
                  statusInfoAll.filter((item) => {
                    return (
                      item.value == "PENDING_CONTACT" ||
                      item.value == "UNREACHABLE"
                    );
                  })
                );
                const currStatus:any = form.formApi.getValue("status");

                if (
                  currStatus != "PENDING_CONTACT" &&
                  currStatus != "UNREACHABLE"
                ) {
                  form.formApi.setValue("status", "PENDING_CONTACT");
                }
              } else if (value == 1) {
                setStatusInfo(
                  statusInfoAll.filter((item) => {
                    return (
                      item.value != "PENDING_CONTACT" &&
                      item.value != "UNREACHABLE"
                    );
                  })
                );
                const currStatus:any = form.formApi.getValue("status");

                if (
                  currStatus == "PENDING_CONTACT" ||
                  currStatus == "UNREACHABLE"
                ) {
                  form.formApi.setValue("status", "PENDING_VISIT");
                }
              } else {
                setStatusInfo(
                  statusInfoAll.filter((item) => {
                    return (
                      item.value != "PENDING_CONTACT" &&
                      item.value != "UNREACHABLE" &&
                      item.value != "OUT_LEAD" &&
                      item.value != "NON_COMPLIANCE"
                    );
                  })
                );
                const currStatus:any = form.formApi.getValue("status");
                if (
                  currStatus == "PENDING_CONTACT" ||
                  currStatus == "UNREACHABLE" ||
                  currStatus == "OUT_LEAD"
                ) {
                  form.formApi.setValue("status", "PENDING_VISIT");
                }
              }
            };

            const statusChangeEvent = (value: any) => {
              if (value == "OUT_LEAD") {
                setStarInfo(
                  starInfoAll.filter((item: any) => {
                    return item.value == 1;
                  })
                );

                form.formApi.setValue("star", 1);

                return;
              } else if (value == "VISITED") {
              } else if (value == "SIGNED_CONTRACT") {
                if (!lead.signedContractAt) {
                  form.formApi.setValue("signedContractAt", new Date());
                }
              } else if (value == "PAID") {
                if (!lead.paidReturnAt) {
                  form.formApi.setValue("paidReturnAt", new Date());
                }
              }

              setStarInfo(starInfoAll);
            };

            const handleFavClick = async () => {
              if (savingFav) {
                return;
              }
              Modal.confirm({
                title: "是否确认设置为重要客户?",
                content: "",
                onOk: async () => {
                  setSavingFav(true);
                  try {
                    await apiClient.request("/leads/fav", "POST", undefined, {
                      leadId: lead?.id,
                      fav: true,
                    });
                    Toast.info("已标记为重要客户");
                    setSavingFav(false);
                    setLeadFav(true);
                    pubsub.publish("refreshMenuCount", "");
                    localStorage.setItem("new-refresh", "true");
                    localStorage.setItem("my-refresh", "true");
                  } catch (e) {
                    setSavingFav(false);
                  }
                },
              });
            };

            const handleUnFavClick = async () => {
              if (savingFav) {
                return;
              }
              Modal.confirm({
                title: "是否确认设置为普通客户?",
                content: "",
                onOk: async () => {
                  setSavingFav(true);
                  try {
                    await apiClient.request("/leads/fav", "POST", undefined, {
                      leadId: lead?.id,
                      fav: false,
                    });
                    Toast.info("已取消标记为重要客户");
                    setSavingFav(false);
                    setLeadFav(false);
                    pubsub.publish("refreshMenuCount", "");
                    localStorage.setItem("fav-refresh", "true");
                  } catch (e) {
                    setSavingFav(false);
                  }
                },
              });
            };

            const handleMyToNewClick = async () => {
              if (savingFav) {
                return;
              }
              Modal.confirm({
                title: "是否确认设置为我的客户?",
                content: "",
                onOk: async () => {
                  setSavingFav(true);
                  try {
                    await apiClient.request(
                      "/leads/setMyToNew",
                      "POST",
                      undefined,
                      {
                        leadId: lead?.id,
                        fav: false,
                      }
                    );
                    Toast.info("已设置为我的客户");
                    setSavingFav(false);
                    setLeadMy(false);
                    pubsub.publish("refreshMenuCount", "");
                    localStorage.setItem("my-refresh", "true");
                    localStorage.setItem("new-refresh", "true");
                  } catch (e) {
                    setSavingFav(false);
                  }
                },
              });
            };

            const handleCallPhone = async () => {
              setContactLogSaving(true);
              try {
                await apiClient.request("/leadCallLog", "POST", undefined, {
                  leadId: leadId,
                });

                Toast.info("拨号成功");
                setContactLogSaving(false);
              } catch (e) {
                setContactLogSaving(false);
              }
            };

            return (
              <>
                {(() => {
                  const legacyFields = detectLegacyFields();
                  return legacyFields.length > 0 ? (
                    <Banner
                      type="warning"
                      description={`该客户存在旧版资质数据（${legacyFields.join('、')}），建议更新为新版选项后保存`}
                      closeIcon={null}
                      style={{ marginBottom: 8 }}
                    />
                  ) : null;
                })()}
                <Row gutter={15} style={{padding:5}}>
                  <Col span={10}>
                    <Section text={"客户信息"}>
                      <Row gutter={10}>
                        <Col span={8}>
                          <Input readonly field="id" label="ID" />
                        </Col>
                        <Col span={8}>
                          <Input field="name" label="姓名" />
                        </Col>
                        <Col span={8}>
                          <Form.RadioGroup field="gender" label="性别" >
                            <Form.Radio value={"男"}>男</Form.Radio>
                            <Form.Radio value={"女"}>女</Form.Radio>
                          </Form.RadioGroup>
                        </Col>
                      </Row>
                      <Row gutter={10}>
                        <Col span={8}>
                          <InputNumber  field="age" label="年龄" />
                        </Col>
                        <Col span={8}>
                            <InputNumber  field="applyAmount" label="申请额度"  />
                        </Col> 
                        <Col span={8}>
                          <Form.Select field="applyCity" label="申请城市" style={{ width: "100%" }}
                            optionList={(dicts["city"] || []).map((o) => ({ value: o.value, label: o.label }))} />
                        </Col>
                      </Row>
                      <Row gutter={10}>
                        <Col span={8}>
                          <Input  field="ipCity" label="现所在城市" />
                        </Col>
                        <Col span={8}>
                            <Input  field="household" label="户籍"  />
                        </Col> 
                        <Col span={8}>
                          
                        </Col>
                      </Row>
                      {(role == "monitor" || role == "root" || role == "op_manager" || (city == "兰州" && (role == "quzhang" || role == "sale_manager" || role == "sale")) || city == "成都" || props.findLeadMode) && (
                        <Row gutter={10}>
                          <Col span={8}>
                            <Input readonly field="source" label="来源" />
                          </Col>
                          <Col span={16}>
                          {renderDictRadio("marriageV2", "marriage", "婚姻", form.formApi)}
                          </Col>
                         
                        </Row>
                      )}
                      {!(role == "monitor" || role == "root" || role == "op_manager" || (city == "兰州" && (role == "quzhang" || role == "sale_manager" || role == "sale")) || city == "成都" || props.findLeadMode) && (
                        <Row gutter={10}>
                         <Col span={24}>
                          {renderDictRadio("marriageV2", "marriage", "婚姻", form.formApi)}
                        </Col>
                        </Row>
                      )}
                    </Section>

                    {/* ====== 资质信息卡片 ====== */}
                    <div style={{
                      background: 'var(--semi-color-bg-2)',
                      borderTop: '1px solid var(--semi-color-border)',
                      borderRadius: 12,
                      border: '1px solid var(--semi-color-border)'
                      
                    }}>
                      <div style={{ display: "flex", width: "100%", marginTop:5, color: 'var(--semi-color-text-0)', justifyContent: "center", alignItems: "center", gap: 16 }}>
                          <Tooltip content="点击打开选项说明">
                            <Button onClick={openHelpPage} type="warning" theme="outline" icon={<IconHelpCircle />}>
                        资质帮助说明
                            </Button>
                          </Tooltip>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <span style={{ fontSize: 12, color: 'var(--semi-color-text-2)' }}>精简</span>
                            <SemiSwitch size="small" checked={compactMode} onChange={v => setCompactMode(v)} />
                          </div>
                           {/* AI 评分徽章 - 点击打开画像页面，hover 显示评分详情 */}
                      <Tooltip
                        position="bottom"
                        content={
                          <div style={{ maxWidth: 280, fontSize: 12, lineHeight: 1.5, backgroundColor:'white',padding:10 }}>
                            <div style={{ fontWeight: 700, marginBottom: 6, color: '#0f172a' }}>AI 评分详情</div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16, marginBottom: 3 }}>
                              <span style={{ color: '#64748b' }}>分值</span>
                              <span style={{ color: '#0f172a', fontWeight: 600 }}>{lead?.score ?? '-'} / 100</span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16 }}>
                              <span style={{ color: '#64748b' }}>评分时间</span>
                              <span style={{ color: '#0f172a' }}>{lead?.scoredAt ? formatDateTime(lead.scoredAt) : '未评'}</span>
                            </div>
                            {lead?.aiConclusion && (
                              <div style={{ marginTop: 6, paddingTop: 6, borderTop: '1px dashed #e2e8f0' }}>
                                <div style={{ color: '#64748b', marginBottom: 2 }}>AI 结论</div>
                                <div style={{ color: '#0f172a' }}>{lead.aiConclusion}</div>
                              </div>
                            )}
                          </div>
                        }
                      >
                        <div
                          onClick={() => window.open(`#/leadProfile?id=${lead?.id || leadId}`, '_blank')}
                          style={{
                            width: 48, height: 48, borderRadius: '50%',
                            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                            cursor: 'pointer', flexShrink: 0,
                            background: lead?.score != null
                              ? (lead.score >= 70 ? 'linear-gradient(135deg, #22c55e, #16a34a)'
                                : lead.score >= 40 ? 'linear-gradient(135deg, #f97316, #ea580c)'
                                : 'linear-gradient(135deg, #ef4444, #dc2626)')
                              : 'linear-gradient(135deg, #94a3b8, #64748b)',
                            color: '#fff', boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                            transition: 'transform 0.15s',
                          }}
                        >
                          <span style={{ fontSize: 18, fontWeight: 800, lineHeight: 1 }}>{lead?.score ?? '-'}</span>
                          <span style={{ fontSize: 8, lineHeight: 1, opacity: 0.85 }}>评分</span>
                        </div>
                      </Tooltip>
                      {lead?.intentionLevel && (
                        <Tooltip
                          position="bottom"
                          content={
                            <div style={{ maxWidth: 280, fontSize: 12, lineHeight: 1.5, backgroundColor:'white',padding:10 }}>
                              <div style={{ fontWeight: 700, marginBottom: 6, color: '#0f172a' }}>意向分析</div>
                              <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16, marginBottom: 6 }}>
                                <span style={{ color: '#64748b' }}>意向等级</span>
                                <span style={{ color: getIntentionColor(lead.intentionLevel), fontWeight: 700 }}>
                                  {lead.intentionLevel} · {getIntentionText(lead.intentionLevel)}
                                </span>
                              </div>
                              {lead.intentionTags?.length ? (
                                <div style={{ marginBottom: 6 }}>
                                  <div style={{ color: '#64748b', marginBottom: 4 }}>意向标签</div>
                                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                                    {lead.intentionTags.map((t, i) => (
                                      <span key={i} style={{
                                        padding: '1px 6px', borderRadius: 4, fontSize: 11,
                                        background: '#dcfce7', color: '#166534', border: '1px solid #bbf7d0',
                                      }}>{t}</span>
                                    ))}
                                  </div>
                                </div>
                              ) : null}
                              {lead.resistancePoints?.length ? (
                                <div>
                                  <div style={{ color: '#64748b', marginBottom: 4 }}>抗拒点</div>
                                  <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                                    {lead.resistancePoints.map((r, i) => (
                                      <span key={i} style={{
                                        padding: '2px 6px', borderRadius: 4, fontSize: 11,
                                        background: '#fee2e2', color: '#991b1b', border: '1px solid #fecaca',
                                      }}>• {r}</span>
                                    ))}
                                  </div>
                                </div>
                              ) : null}
                            </div>
                          }
                        >
                          <span style={{
                            display: "inline-flex", alignItems: "center", justifyContent: "center",
                            width: 48, height: 48, borderRadius: "50%",
                            background: getIntentionColor(lead.intentionLevel),
                            color: "#fff", fontSize: 14, fontWeight: 700, marginLeft: 6,
                            cursor: 'default',
                          }}>{getIntentionText(lead.intentionLevel)}</span>
                        </Tooltip>
                      )}
                      <Button onClick={() => {
                        const hasExistingScore = lead?.score != null && lead.score > 0;
                        let currentMode: 'dict' | 'text' = 'dict';
                        Modal.confirm({
                          title: hasExistingScore ? '重新 AI 评分' : 'AI 客户画像评分',
                          style: { width: 520 },
                          content: (
                            <div>
                              {hasExistingScore && (
                                <div style={{
                                  background: '#fffbeb', border: '1px solid #fbbf24', borderRadius: 8,
                                  padding: '8px 12px', marginBottom: 12, fontSize: 13, color: '#92400e',
                                }}>
                                  <IconAlertTriangle size="small" style={{ color: '#d97706', marginRight: 4 }} />该客户已有 AI 评分（{lead.score} 分），重新评分将覆盖现有数据。
                                  <a
                                    onClick={() => {
                                      window.open(`#/leadProfile?id=${lead?.id || leadId}`, '_blank');
                                    }}
                                    style={{ cursor: 'pointer', marginLeft: 8, color: '#2563eb' }}
                                  >
                                    查看现有画像 →
                                  </a>
                                </div>
                              )}
                              <p style={{ marginBottom: 12 }}>
                                {hasExistingScore ? '是否重新生成画像评分？' : '将通过大模型分析客户资质并生成画像评分，是否继续？'}
                              </p>
                              <div style={{ marginBottom: 8, fontWeight: 600, fontSize: 13 }}>输入模式：</div>
                              <SemiRadio.Group
                                type="button"
                                defaultValue="dict"
                                onChange={(e: any) => { currentMode = e.target.value; }}
                              >
                                <SemiRadio value="dict">字典模式（推荐）</SemiRadio>
                                <SemiRadio value="text">文本模式</SemiRadio>
                              </SemiRadio.Group>
                              <div style={{
                                marginTop: 12, padding: '10px 14px', borderRadius: 8,
                                background: '#f8fafc', border: '1px solid #e2e8f0',
                                fontSize: 12, lineHeight: 1.7, color: '#475569',
                              }}>
                                <div style={{ marginBottom: 4 }}><strong style={{ color: '#1d4ed8' }}>字典模式</strong>：将客户档案中的字典字段（性别、婚姻、工作、收入、房产、车辆、社保、征信等）+ 资质备注拼接为结构化文本，数据更完整，画像更准确。</div>
                                <div><strong style={{ color: '#6d28d9' }}>文本模式</strong>：仅使用资质备注原文。适合备注已经足够详细，或字典字段尚未完善填写的客户。</div>
                              </div>
                            </div>
                          ),
                          onOk: async () => {
                            setLlmScoring(true);
                            try {
                              await apiClient.request('/qualification/llmScore', 'POST', {
                                leadId: lead?.id || leadId,
                                mode: currentMode,
                              });
                              Toast.success('AI评分完成');
                              await loadLead();
                            } catch (e: any) {
                              Toast.error(e?.message || 'AI评分失败');
                            } finally {
                              setLlmScoring(false);
                            }
                          }
                        });
                      }} icon={<IconStar />} type="warning" theme="light" size="large" loading={llmScoring}>
                        AI评分
                      </Button>
                     </div>

                      {/* 贷款类型 - 多选 */}
                      {(role == "monitor" || role == "root" || role == "op_manager" || (city == "兰州" && (role == "quzhang" || role == "sale_manager" || role == "sale")) || city == "成都" || props.findLeadMode) && (
                        <div style={{ borderBottom: '1px solid var(--semi-color-border)' }}>
                          {renderDictMultiSelect("loanTypeV2", "loanType", "贷款类型", form.formApi)}
                        </div>
                      )}

                      {/* 房产 - 多选 */}
                      <div style={{  borderBottom: '1px solid var(--semi-color-border)' }}>
                        {renderDictMultiSelect("houseV2", "house", "房产", form.formApi)}
                      </div>

                      {/* 车产 - 多选 */}
                      <div style={{  borderBottom: '1px solid var(--semi-color-border)' }}>
                        {renderDictMultiSelect("vehicleV2", "vehicle", "车产", form.formApi)}
                      </div>

                      {/* 公司 */}
                      <div style={{ padding: '2px 0', borderBottom: '1px solid var(--semi-color-border)' }}>
                        {renderDictRadio("companyV2", "company", "公司", form.formApi)}
                      </div>

                      {/* 公积金 */}
                      <div style={{ padding: '2px 0', borderBottom: '1px solid var(--semi-color-border)' }}>
                        {renderDictRadio("providentFundV2", "providentFund", "公积金", form.formApi)}
                      </div>

                      {/* 社保 */}
                      <div style={{ padding: '2px 0', borderBottom: '1px solid var(--semi-color-border)' }}>
                        {renderDictRadio("socialSecurityV2", "socialSecurity", "社保", form.formApi)}
                      </div>

                      {/* 收入 */}
                      <div style={{ padding: '2px 0', borderBottom: '1px solid var(--semi-color-border)' }}>
                        {renderDictRadio("incomeV2", "income", "收入", form.formApi)}
                      </div>

                      {/* 工作年限 */}
                      <div style={{ padding: '2px 0', borderBottom: '1px solid var(--semi-color-border)' }}>
                        {renderDictRadio("workYearsV2", "workYears", "工作年限", form.formApi)}
                      </div>

                      {/* 征信 */}
                      <div style={{ padding: '2px 0', borderBottom: '1px solid var(--semi-color-border)' }}>
                        {renderDictRadio("creditV2", "credit", "征信", form.formApi)}
                      </div>
                      <Row>
                          <Col span={24}>
                            <TextArea autosize field="remark" label="资质描述" />
                          </Col>
                      </Row>
                      </div>
                      <div>

                      {/* 公司名称 */}
                      <div style={{ padding: '2px 0', borderBottom: '1px solid var(--semi-color-border)', display: 'flex', gap: 5 }}>
                        <div style={{ flex: 1 }}>
                        <Input field="companyName" label="公司名称" />
                        </div>
                         {/* 白名单 */}
                         <div style={{ flex: 1 }}>
                         <Input field="whiteBankName" label="白名单" readonly />
                        </div>
                      </div>
                      

                      {/* 代发银行 + 代发工资 */}
                      <div style={{ padding: '2px 0', borderBottom: '1px solid var(--semi-color-border)', display: 'flex', gap: 5 }}>
                        <div style={{ flex: 1 }}>
                          <Input field="salaryBankName" label="代发银行" />
                        </div>
                        <div style={{ flex: 1 }}>
                          <Input field="salary" label="代发工资" />
                        </div>
                        <div style={{ flex: 1 }}>
                          <Input field="providentFundBasic" label="公积金基数" />
                        </div>
                      </div>

                      {/* 释放日期 + 签约点位 */}
                      <div style={{ padding: '2px 0', borderBottom: '1px solid var(--semi-color-border)', display: 'flex', gap: 5 }}>
                        <div style={{ flex: 1 }}>
                          <DatePicker type="date" style={{ width: '100%' }} field="settledLoanAt" label="释放日期" disabled />
                        </div>
                        <div style={{ flex: 1 }}>
                          <Input field="loanPoint" label="签约点位" />
                        </div>
                        <div style={{ flex: 1 }}>
                          <Input field="education" label="学历" />
                        </div>
                      </div>

                     
                    </div>

                    
                  </Col>
                  <Col span={9}>
                    <Section text={"客户跟进"}>
                       {/* ====== 顶部客户概览卡片 ====== */}
                <div style={{
                  display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px',
                  background: 'linear-gradient(135deg, var(--semi-color-primary-light) 0%, var(--semi-color-bg-2) 100%)',
                  borderRadius: 12, marginBottom: 12,
                  border: '1px solid var(--semi-color-border)',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                }}>
                  <div style={{ flex: 1 }}>
                    {showMobile && lead && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                        <span style={{ fontSize: 18, fontWeight: 700, color: 'var(--semi-color-text-0)' }}>
                          {lead.name}
                        </span>
                        <span style={{ fontSize: 15, color: 'var(--semi-color-text-1)' }}>
                          {lead.fullMobile}
                        </span>
                      </div>
                    )}
                    {lead?.userAgreement && (
                      <a href={lead.userAgreement} target="_blank" rel="noopener noreferrer" 
                         style={{ fontSize: 12, color: 'var(--semi-color-primary)', textDecoration: 'none' }}>
                        <IconFile size="small" style={{ marginRight: 4 }} />用户授权协议
                      </a>
                    )}
                  </div>
                  {showMobile && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                     
                    
                      <Button onClick={handleCallPhone} icon={<IconUserCardPhone />} type="danger" theme="solid" size="large">
                        拨号
                      </Button>
                      <Tooltip style={{ maxWidth: 400 }} content={callPhoneHelp}>
                        <IconHelpCircle style={{ color: "#E91E63", fontSize: 18, cursor: 'pointer' }} />
                      </Tooltip>
                    </div>
                  )}
                </div>

                      {/* ====== 星级状态卡片 ====== */}
                      <div style={{
                        background: 'var(--semi-color-bg-2)',
                        borderRadius: 12,
                        padding: '12px 16px',
                        marginBottom: 12,
                        border: '1px solid var(--semi-color-border)'
                      }}>
                        <div style={{ 
                          fontSize: 13, 
                          fontWeight: 600, 
                          color: 'var(--semi-color-text-0)',
                          marginBottom: 12,
                          display: 'flex',
                          alignItems: 'center',
                          gap: 6
                        }}>
                          <IconStar size="small" style={{ color: '#f59e0b' }} /> 星级与状态
                        </div>
                        <Row gutter={12}>
                          <Col span={12}>
                            <Form.Select
                              field="star"
                              label={{
                                text: "星级",
                                extra: (
                                  <Tooltip style={{ maxWidth: 400 }} content={starHelp}>
                                    <IconHelpCircle style={{ color: "#E91E63" }} />
                                  </Tooltip>
                                ),
                              }}
                              onChange={starChangeEvent}
                            >
                              {starInfo.map((pro) => (
                                <Select.Option value={pro.value} key={pro.value}>
                                  {pro.label}
                                </Select.Option>
                              ))}
                            </Form.Select>
                          </Col>
                          <Col span={12}>
                            <Form.Select
                              field="status"
                              label="状态"
                              onChange={statusChangeEvent}
                            >
                              {statusInfo.map((pro) => (
                                <Select.Option
                                  value={pro.value}
                                  key={pro.value}
                                  disabled={readOnlyLeadStatus.includes(displayLeadStatus(pro.value))}
                                >
                                  {pro.label}
                                </Select.Option>
                              ))}
                            </Form.Select>
                          </Col>
                        </Row>
                      </div>

                      {/* ====== 时间节点卡片 ====== */}
                      <div style={{
                        background: 'var(--semi-color-bg-2)',
                        borderRadius: 12,
                        padding: '12px 16px',
                        marginBottom: 12,
                        border: '1px solid var(--semi-color-border)'
                      }}>
                        <div style={{ 
                          fontSize: 13, 
                          fontWeight: 600, 
                          color: 'var(--semi-color-text-0)',
                          marginBottom: 12,
                          display: 'flex',
                          alignItems: 'center',
                          gap: 6
                        }}>
                          <IconCalendar size="small" /> 时间节点
                        </div>
                        <Row gutter={12}>
                          <Col span={12}>
                            <Form.DatePicker type="dateTime" style={{ width: "100%" }} field="estVisitTime" label="预计上门" />
                          </Col>
                          <Col span={12}>
                            <Form.DatePicker
                              type="dateTime"
                              style={{ width: "100%" }}
                              field="actVisitTimeNew"
                              disabled={actVisitTimeDisabled}
                              label={{
                                text: "实际上门",
                                extra: (
                                  <Tooltip style={{ maxWidth: 400, wordBreak: "break-all", whiteSpace: "pre-wrap" }} content={visitSignLogText}>
                                    <IconHelpCircle style={{ color: "#E91E63" }} />
                                  </Tooltip>
                                ),
                              }}
                            />
                          </Col>
                          <Col span={12}>
                            <Form.DatePicker type="dateTime" style={{ width: "100%" }} field="signedContractAt" label="签约时间" />
                          </Col>
                          <Col span={12}>
                            <Form.DatePicker type="dateTime" style={{ width: "100%" }} field="paidReturnAt" label="回款时间" />
                          </Col>
                        </Row>
                      </div>

                      {/* ====== 跟进记录输入卡片 ====== */}
                      <div style={{
                        background: 'var(--semi-color-bg-2)',
                        borderRadius: 12,
                        padding: '12px 16px',
                        marginBottom: 12,
                        border: '1px solid var(--semi-color-border)'
                      }}>
                        <div style={{ 
                          fontSize: 13, 
                          fontWeight: 600, 
                          color: 'var(--semi-color-text-0)',
                          marginBottom: 12,
                          display: 'flex',
                          alignItems: 'center',
                          gap: 6
                        }}>
                          <IconEdit size="small" /> 跟进记录
                        </div>
                        <Row>
                          <Col span={24}>
                            <Form.TextArea
                              autoFocus
                              style={{ width: "100%" }}
                              field="content"
                              noLabel
                              placeholder="请输入跟进内容..."
                              rows={3}
                            />
                            <Form.Slot noLabel>
                              <div style={{ marginTop: 8 }}>
                                <div style={{ 
                                  fontSize: 12, 
                                  color: 'var(--semi-color-text-2)',
                                  marginBottom: 6
                                }}>
                                  快捷模板：
                                </div>
                                <Space wrap style={{ gap: 6 }}>
                                  {contactLogTemplate.map((t: any) => (
                                    <Button
                                      size="small"
                                      theme="light"
                                      key={t}
                                      onClick={() => form.formApi.setValue("content", t)}
                                      style={{ 
                                        borderRadius: 16, 
                                        fontSize: 12, 
                                        padding: '0 12px', 
                                        height: 28,
                                        background: 'var(--semi-color-fill-0)'
                                      }}
                                    >
                                      {t}
                                    </Button>
                                  ))}
                                </Space>
                              </div>
                            </Form.Slot>
                          </Col>
                        </Row>
                      </div>

                      {/* 操作工具栏 */}
                      {(!props.viewMode || props.visitMode) && (
                        <div style={{
                          background: 'var(--semi-color-bg-2)',
                          borderRadius: 12,
                          padding: '12px 16px',
                          marginBottom: 12,
                          border: '1px solid var(--semi-color-border)'
                        }}>
                          <Space wrap style={{ gap: 8 }}>
                            <Button size="large" icon={<IconSave />} theme="solid" type="primary" onClick={handleSubmit} loading={leadSaving || loadingAll}>
                              保存
                            </Button>
                            <Button icon={<IconBell />} type="secondary" onClick={() => setShowTodo(true)}>提醒</Button>
                            <Button icon={<IconRotate />} type="danger" theme="light" onClick={handleSendToPool}>公共池</Button>
                            <Button icon={<IconRefresh />} type="warning" theme="light" onClick={handleSendToReassignPool}>退回到再分配池</Button>
                            {!leadFav ? (
                              <Button icon={<IconLikeHeart />} type="secondary" onClick={handleFavClick}>重要</Button>
                            ) : (
                              <Button icon={<IconLikeHeart />} type="warning" onClick={handleUnFavClick}>取消重要</Button>
                            )}
                            {leadMy && (
                              <Button icon={<IconCopy />} type="secondary" onClick={handleMyToNewClick}>我的客户</Button>
                            )}
                            {hasAssignPriv && (
                              <Button icon={<IconBookmark />} type="secondary" onClick={handleAssignButtonClick}>分配</Button>
                            )}
                          </Space>
                        </div>
                      )}

                      {props.leadFrom != "reportShow" && (
                        <div style={{
                          background: 'var(--semi-color-bg-2)',
                          borderRadius: 12,
                          padding: '12px 16px',
                          border: '1px solid var(--semi-color-border)'
                        }}>
                          <Space style={{ gap: 8 }}>
                            <Button icon={<IconChevronLeft />} loading={loadingAll} onClick={handlePrevClick}>上一条</Button>
                            <Button icon={<IconChevronRight />} iconPosition="right" loading={loadingAll} onClick={handleNextClick}>下一条</Button>
                          </Space>
                        </div>
                      )}
                    </Section>
                  </Col>

                  <Col span={5}>
                    <Tabs type="line" defaultActiveKey="contactLogs">
                      <TabPane tab="跟进记录" itemKey="contactLogs">
                        <div style={{ padding: '2px 0' }}>
                          {leadContactLogs.length === 0 ? (
                            <div style={{ 
                              textAlign: 'center', 
                              padding: '40px 0', 
                              color: 'var(--semi-color-text-2)'
                            }}>
                              暂无跟进记录
                            </div>
                          ) : (
                            <List<LeadContactLog>
                              dataSource={leadContactLogs}
                              style={{ overflowY: "auto", maxHeight: 'calc(100vh - 260px)' }}
                              renderItem={(l, index: number) => (
                                <div style={{
                                  position: 'relative',
                                  paddingLeft: 24,
                                  paddingBottom: index < leadContactLogs.length - 1 ? 20 : 0,
                                  borderLeft: index < leadContactLogs.length - 1 ? '2px solid var(--semi-color-border)' : 'none',
                                  marginLeft: 12
                                }}>
                                  {/* 时间轴节点 */}
                                  <div style={{
                                    position: 'absolute',
                                    left: -6,
                                    top: 4,
                                    width: 10,
                                    height: 10,
                                    borderRadius: '50%',
                                    background: 'var(--semi-color-success)',
                                    border: '2px solid var(--semi-color-bg-0)'
                                  }} />
                                  
                                  {/* 跟进记录卡片 */}
                                  <div style={{
                                    background: 'var(--semi-color-fill-0)',
                                    borderRadius: 8,
                                    padding: '12px 16px',
                                    marginBottom: 8
                                  }}>
                                    {/* 头部信息 */}
                                    <div style={{ 
                                      display: 'flex', 
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      marginBottom: 8
                                    }}>
                                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <span style={{ 
                                          fontWeight: 600, 
                                          fontSize: 14,
                                          color: 'var(--semi-color-success)'
                                        }}>
                                          {l.saleName}
                                        </span>
                                        <Tag size="small" color="green">跟进</Tag>
                                      </div>
                                      <span style={{ 
                                        fontSize: 12, 
                                        color: 'var(--semi-color-text-2)'
                                      }}>
                                        {formatRelativeTime(l.createdAt)}
                                      </span>
                                    </div>
                                    
                                    {/* 跟进内容 */}
                                    <div style={{
                                      padding: '10px 12px',
                                      background: 'var(--semi-color-bg-0)',
                                      borderRadius: 6,
                                      fontSize: 13,
                                      color: 'var(--semi-color-text-0)',
                                      lineHeight: 1.6,
                                      whiteSpace: 'pre-wrap'
                                    }}>
                                      {l.content}
                                    </div>
                                  </div>
                                </div>
                              )}
                            />
                          )}
                        </div>
                      </TabPane>
                       <TabPane tab="分配记录" itemKey="assignLogs">
                        <div style={{ padding: '2px 0' }}>
                          {leadAssignLogs.length === 0 ? (
                            <div style={{ 
                              textAlign: 'center', 
                              padding: '40px 0', 
                              color: 'var(--semi-color-text-2)'
                            }}>
                              暂无分配记录
                            </div>
                          ) : (
                            <List<LeadAssignLog>
                              dataSource={leadAssignLogs}
                              style={{ overflowY: "auto", maxHeight: 'calc(100vh - 260px)' }}
                              renderItem={(l: LeadAssignLog, index: number) => (
                                <div style={{
                                  position: 'relative',
                                  paddingLeft: 24,
                                  paddingBottom: index < leadAssignLogs.length - 1 ? 20 : 0,
                                  borderLeft: index < leadAssignLogs.length - 1 ? '2px solid var(--semi-color-border)' : 'none',
                                  marginLeft: 12
                                }}>
                                  {/* 时间轴节点 */}
                                  <div style={{
                                    position: 'absolute',
                                    left: -6,
                                    top: 4,
                                    width: 10,
                                    height: 10,
                                    borderRadius: '50%',
                                    background: 'var(--semi-color-primary)',
                                    border: '2px solid var(--semi-color-bg-0)'
                                  }} />
                                  
                                  {/* 分配记录卡片 */}
                                  <div style={{
                                    background: 'var(--semi-color-fill-0)',
                                    borderRadius: 8,
                                    padding: '12px 16px',
                                    marginBottom: 8
                                  }}>
                                    {/* 分配流程：分配者 → 接收者 */}
                                    <div style={{ 
                                      display: 'flex', 
                                      alignItems: 'center',
                                      gap: 2,
                                      marginBottom: 8
                                    }}>
                                      {/* 分配者 */}
                                      <div style={{
                                        padding: '1px 1px',
                                        background: 'var(--semi-color-warning-light)',
                                        borderRadius: 6,
                                        fontSize: 13,
                                        fontWeight: 500,
                                        color: 'var(--semi-color-text-0)'
                                      }}>
                                        {l.assignBy}
                                      </div>
                                      
                                      {/* 箭头 */}
                                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
                                        <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="var(--semi-color-primary)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                      </svg>
                                      
                                      {/* 接收者 */}
                                      <div style={{
                                        padding: '1px 1px',
                                        background: 'var(--semi-color-primary-light)',
                                        borderRadius: 6,
                                        fontSize: 13,
                                        fontWeight: 600,
                                        color: 'var(--semi-color-text-0)'
                                      }}>
                                        {l.saleName}
                                      </div>
                                      
                                      {/* 时间 */}
                                      <span style={{ 
                                        fontSize: 12, 
                                        color: 'var(--semi-color-text-2)',
                                        marginLeft: 'auto'
                                      }}>
                                        {formatRelativeTime(l.createdAt)}
                                      </span>
                                    </div>
                                    
                                    {/* 备注信息 */}
                                    {l.remark && (
                                      <div style={{
                                        padding: '8px 12px',
                                        background: 'var(--semi-color-bg-0)',
                                        borderRadius: 6,
                                        fontSize: 13,
                                        color: 'var(--semi-color-text-0)',
                                        lineHeight: 1.6
                                      }}>
                                        {l.remark}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                            />
                          )}
                        </div>
                      </TabPane>
                      <TabPane tab="星级状态" itemKey="starLogs">
                        <div style={{ padding: '2px 0' }}>
                          {leadStarLogs.length === 0 ? (
                            <div style={{ 
                              textAlign: 'center', 
                              padding: '40px 0', 
                              color: 'var(--semi-color-text-2)'
                            }}>
                              暂无星级状态记录
                            </div>
                          ) : (
                            <List<LeadStarLog>
                              dataSource={leadStarLogs}
                              style={{ overflowY: "auto", maxHeight: 'calc(100vh - 260px)' }}
                              renderItem={(l, index: number) => (
                                <div style={{
                                  position: 'relative',
                                  paddingLeft: 24,
                                  paddingBottom: index < leadStarLogs.length - 1 ? 20 : 0,
                                  borderLeft: index < leadStarLogs.length - 1 ? '2px solid var(--semi-color-border)' : 'none',
                                  marginLeft: 12
                                }}>
                                  {/* 时间轴节点 */}
                                  <div style={{
                                    position: 'absolute',
                                    left: -6,
                                    top: 4,
                                    width: 10,
                                    height: 10,
                                    borderRadius: '50%',
                                    background: 'var(--semi-color-primary)',
                                    border: '2px solid var(--semi-color-bg-0)'
                                  }} />
                                  
                                  {/* 星级状态卡片 */}
                                  <div style={{
                                    background: 'var(--semi-color-fill-0)',
                                    borderRadius: 8,
                                    padding: '12px 16px',
                                    marginBottom: 8
                                  }}>
                                    {/* 头部信息 */}
                                    <div style={{ 
                                      display: 'flex', 
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      marginBottom: 8
                                    }}>
                                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <span style={{ 
                                          fontWeight: 600, 
                                          fontSize: 14,
                                          color: 'var(--semi-color-text-0)'
                                        }}>
                                          {l.saleName}
                                        </span>
                                        <Tag size="small" color="blue">状态变更</Tag>
                                      </div>
                                      <span style={{ 
                                        fontSize: 12, 
                                        color: 'var(--semi-color-text-2)'
                                      }}>
                                        {formatRelativeTime(l.createdAt)}
                                      </span>
                                    </div>
                                    
                                    {/* 星级和状态 */}
                                    <div style={{ 
                                      display: 'flex', 
                                      alignItems: 'center',
                                      gap: 12,
                                      padding: '8px 12px',
                                      background: 'var(--semi-color-bg-0)',
                                      borderRadius: 6,
                                      marginBottom: 8
                                    }}>
                                      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                        <span style={{ fontSize: 13, color: 'var(--semi-color-text-2)' }}>星级：</span>
                                        <span style={{ 
                                          fontWeight: 600,
                                          fontSize: 14,
                                          color: 'var(--semi-color-warning)'
                                        }}>
                                          {displayStar(l.star)}
                                        </span>
                                      </div>
                                      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                        <span style={{ fontSize: 13, color: 'var(--semi-color-text-2)' }}>状态：</span>
                                        <Tag size="small">{displayLeadStatus(l.status)}</Tag>
                                      </div>
                                    </div>
                                    
                                    {/* 备注信息 */}
                                    {l.remark && (
                                      <div style={{
                                        padding: '8px 12px',
                                        background: 'var(--semi-color-warning-light)',
                                        borderRadius: 6,
                                        fontSize: 13,
                                        color: 'var(--semi-color-text-0)',
                                        lineHeight: 1.6
                                      }}>
                                        {l.remark}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                            />
                          )}
                        </div>
                      </TabPane>
                     
                      <TabPane tab="通话记录" itemKey="callLogs">
                        <div style={{ padding: '2px 0' }}>
                          {callLogs.length === 0 ? (
                            <div style={{ 
                              textAlign: 'center', 
                              padding: '40px 0', 
                              color: 'var(--semi-color-text-2)'
                            }}>
                              暂无通话记录
                            </div>
                          ) : (
                            <List<CallLogItem>
                              dataSource={callLogs}
                              style={{ overflowY: "auto", maxHeight: 'calc(100vh - 260px)' }}
                              renderItem={(l, index: number) => (
                                <div style={{
                                  position: 'relative',
                                  paddingLeft: 24,
                                  paddingBottom: index < callLogs.length - 1 ? 20 : 0,
                                  borderLeft: index < callLogs.length - 1 ? '2px solid var(--semi-color-border)' : 'none',
                                  marginLeft: 12
                                }}>
                                  {/* 时间轴节点 */}
                                  <div style={{
                                    position: 'absolute',
                                    left: -6,
                                    top: 4,
                                    width: 10,
                                    height: 10,
                                    borderRadius: '50%',
                                    background: callStatusColors[l.status] === 'green' ? 'var(--semi-color-success)' : callStatusColors[l.status] === 'red' ? 'var(--semi-color-danger)' : 'var(--semi-color-primary)',
                                    border: '2px solid var(--semi-color-bg-0)'
                                  }} />
                                  
                                  {/* 通话记录卡片 */}
                                  <div style={{
                                    background: 'var(--semi-color-fill-0)',
                                    borderRadius: 8,
                                    padding: '12px 16px',
                                    marginBottom: 8
                                  }}>
                                    {/* 头部信息 */}
                                    <div style={{ 
                                      display: 'flex', 
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      marginBottom: 8
                                    }}>
                                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <Tag size="small" color={callStatusColors[l.status] || 'grey'} type="solid">
                                          {callStatusLabels[l.status] || l.status}
                                        </Tag>
                                        <span style={{ fontSize: 13, color: 'var(--semi-color-text-0)' }}>
                                          {l.saleName}
                                        </span>
                                      </div>
                                      <span style={{ 
                                        fontSize: 12, 
                                        color: 'var(--semi-color-text-2)'
                                      }}>
                                        {l.callAt}
                                      </span>
                                    </div>
                                    
                                    {/* 通话详情 */}
                                    <div style={{
                                      padding: '8px 12px',
                                      background: 'var(--semi-color-bg-0)',
                                      borderRadius: 6,
                                      fontSize: 13,
                                      color: 'var(--semi-color-text-0)',
                                      lineHeight: 1.8,
                                      display: 'flex',
                                      flexWrap: 'wrap',
                                      gap: '4px 16px'
                                    }}>
                                      <span>通话时长：<b>{formatCallSeconds(l.callTimeLong)}</b></span>
                                      {l.startAt && <span>接通：{l.startAt}</span>}
                                      {l.recordUploaded && l.recordFile ? (
                                        <Button
                                          theme="borderless"
                                          type="primary"
                                          icon={<IconPlay />}
                                          size="small"
                                          onClick={() => playCallAudio(l.recordFile, l.recordName || l.leadName || '录音')}
                                        >
                                          播放录音
                                        </Button>
                                      ) : (
                                        <span style={{ color: 'var(--semi-color-text-2)' }}>无录音</span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              )}
                            />
                          )}
                        </div>
                      </TabPane>
                    </Tabs>
                  </Col>
                </Row>
              </>
            );
          }}
        ></Form>
     </Modal>
       <SideSheet title="客户资质说明" visible={helpVisible}  onCancel={()=>setHelpVisible(!helpVisible)} placement="right" size="large">
          <iframe src={`/mis/dict-help.html?category=${activeHelpCategory}`} style={{ width: '100%', height: '99%', border: 'none' }} />       
      </SideSheet>

      {/* 录音播放弹窗 */}
      <AudioPlayerModal
        visible={callAudioVisible}
        url={callAudioUrl}
        title={callAudioTitle}
        onClose={closeCallAudio}
      />
     
    </div>
  );
}
